import { render, staticRenderFns } from "./FormMateri.vue?vue&type=template&id=31358ba5"
import script from "./FormMateri.vue?vue&type=script&lang=js"
export * from "./FormMateri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports